/**
 * Recuerda temporada / capítulo al salir del watch o al navegar la ficha.
 * Clave por perfil + slug de serie.
 */

const STORAGE_KEY = "cs_series_resume";

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(map) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* quota / private mode */
  }
}

function resumeKey(profileId, slug) {
  return `${profileId || "anon"}:${slug}`;
}

export function loadSeriesResume(profileId, slug) {
  if (!slug) return null;
  const entry = readAll()[resumeKey(profileId, slug)];
  if (!entry || typeof entry !== "object") return null;
  const season = Number(entry.season);
  const episodeId = Number(entry.episodeId);
  if (!Number.isFinite(season) || season < 1) return null;
  return {
    season,
    episodeId: Number.isFinite(episodeId) && episodeId > 0 ? episodeId : null,
    updatedAt: Number(entry.updatedAt) || 0,
  };
}

export function saveSeriesResume(profileId, slug, { season, episodeId } = {}) {
  if (!slug) return;
  const sn = Number(season);
  if (!Number.isFinite(sn) || sn < 1) return;
  const map = readAll();
  map[resumeKey(profileId, slug)] = {
    season: sn,
    episodeId: episodeId != null ? Number(episodeId) || null : null,
    updatedAt: Date.now(),
  };
  writeAll(map);
}

/** Elige temporada inicial: ?season= > resume local > progreso reciente en items > primera. */
export function pickResumeSeason(show, { profileId, querySeason } = {}) {
  if (!show?.seasons?.length) return null;
  const seasons = show.seasons.map(Number);

  if (querySeason != null && querySeason !== "") {
    const q = Number(querySeason);
    if (seasons.includes(q)) return q;
  }

  const saved = loadSeriesResume(profileId, show.slug);
  if (saved && seasons.includes(saved.season)) return saved.season;

  // Capítulo con más progreso / visto recientemente entre los items cargados
  let best = null;
  for (const ep of show.items || []) {
    const pct = Number(ep.progress_percent) || 0;
    const pos = Number(ep.position_seconds) || 0;
    if (pct <= 0 && pos < 5) continue;
    const sn =
      ep.season_number == null || Number.isNaN(Number(ep.season_number))
        ? 1
        : Number(ep.season_number);
    const score = pct * 1000 + pos;
    if (!best || score > best.score) best = { season: sn, score };
  }
  if (best && seasons.includes(best.season)) return best.season;

  return seasons[0];
}
